// extracted by mini-css-extract-plugin
module.exports = {"list":"_13N3e"};